// for whatever reason, google URLs do not include the padding "=" at the end of a base64 encoded strings
// maybe because Apache does the same to shorten urls? https://stackoverflow.com/a/4797861/1162945
export function removeEndPadding(encoded: string): string {
  // Remove =, if present.
  encoded = removeTrailingEqualSign(encoded);
  // Remove second =, if present.
  encoded = removeTrailingEqualSign(encoded);
  return encoded;
}

const removeTrailingEqualSign = (encoded: string) => {
  if (!encoded.length) {
    return encoded;
  }

  if (encoded[encoded.length - 1] === "=") {
    return encoded.substring(0, encoded.length - 1);
  }

  return encoded;
};

// Important to removeEndPadding from the result of btoa.
export const generateGcalEventLink = (externalEventId: string, calendarId: string) => {
  const eventUrl = removeEndPadding(btoa(`${externalEventId} ${calendarId}`));
  return `https://calendar.google.com/calendar/u/0/r/week?authuser=${calendarId}&eid=${eventUrl}`;
};
